var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'category-entity',
    {'category-entity__parent': !_vm.isChild},
    {'category-entity__child': _vm.isChild},
  ],on:{"click":_vm.onClick}},[_c('span',[_vm._v(" "+_vm._s(_vm.category.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }